import { mapGetters } from 'vuex'
export default {
  data() {
    return {
     route: null
    }
  },
  created() {
    this.route = this.$route.name
    this.setlistParams()
  },
  computed: {
    ...mapGetters(['sortParams','listParams']),
  },
  beforeDestroy() {
      if(this.sortParams && this.sortParams.sort){
        this.$store.dispatch('sortParams', {
          sort: this.sortParams.sort,
          sortDesc: this.sortParams.sortDesc,
          direction: this.sortParams.direction,
          route: this.route,
          show: true
        })
      }
  },
  methods: {
    setlistParams(){
      if (this.listParams && (this.pagination.pageSize != this.listParams.pageSize) && (this.listParams.pageSize != null)) {
        this.pagination.pageSize = this.listParams.pageSize
      } 
      // page
      if (this.listParams && this.listParams.route === this.$route.name) {
          this.pagination.page = this.listParams.page
      }
    },
    setSortParams() {
      if (this.sortParams.show && this.sortParams.route === this.$route.name) {
        this.$store.dispatch('sortParams', {
          sort: this.sortParams.sort,
          sortDesc: this.sortParams.sortDesc,
          direction: this.sortParams.direction,
          route: this.$route.name,
          show: false,
        })
      } else {
        this.$store.dispatch('sortParams', {
          sort: this.pagination.sort,
          sortDesc: this.pagination.sortDesc,
          direction: this.pagination.direction,
          route: this.$route.name,
        })
      }
      if (
        this.sortParams &&
        this.sortParams.sort &&
        this.pagination.sort != this.sortParams.sort && 
        this.sortParams.route === this.$route.name
      ) {
        this.pagination.sort = this.sortParams.sort
        this.pagination.sortDesc = this.sortParams.sortDesc
        this.pagination.direction = this.sortParams.direction
      }
    },
  },
}
